import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../images/logo_paedcompenda_inverted.png'
import _imports_1 from '../../../../images/logo_paedcompenda.png'


const _withScopeId = n => (_pushScopeId("data-v-c00a30f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__logo-paedcompenda" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}


export default /*#__PURE__*/_defineComponent({
  __name: 'logo-paedcompenda',
  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        (__props.inverted)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : (_openBlock(), _createElementBlock("img", _hoisted_3))
      ]),
      _: 1
    })
  ]))
}
}

})